import React, { lazy, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { loadRemote } from '@module-federation/enhanced/runtime';
import { isMembershipEnrollURL } from '../util/routeUtils';

const Header = lazy(() => loadRemote('headerMfe/Header'));
const Footer = lazy(() => loadRemote('footerMfe/Footer'));

function AppLayout(props) {
  const {
    pageData: { header = {}, footer = {}, importMaps = {} },
    storeConf = {},
  } = props || {};
  const location = useLocation();

  return (
    <>
      {location && !isMembershipEnrollURL(location.pathname) && (
        <Suspense fallback={<div />}>
          <Header data={header} importMaps={importMaps} storeConf={storeConf} />
        </Suspense>
      )}
      <main>
        <Suspense fallback={<div />}>
          <Outlet />
        </Suspense>
      </main>
      <Suspense fallback={<div />}>
        <Footer data={footer} storeConf={storeConf} />
      </Suspense>
    </>
  );
}

export default AppLayout;
